/* L'Adele v89 (TD96 en TD96b): venster Kies je sets, (v97 TD-W1: ook zonder set vanaf de bundelkaart op de homepage, data-ldd-handle leeg; staffel B per set) 6 vakjes (1 en 2 nodig, 3 tot 6 optioneel). Opent vanaf elke knop met data-ldd-open (productpagina en het vak tweede set in de lade).
   Haalt sections/ladele-duo-venster op in de taal en het land van de bezoeker, laat per set shape en maat kiezen en voegt alles in een keer toe
   met /cart/add.js en de verborgen regeleigenschap _duo. De korting zelf geeft Shopify (2 sets · 10%); label en knopprijs
   komen uit de thema-instellingen L'Adele bundel (percentage per aantal en een vast bedrag per set), via sections/ladele-duo-venster. */
(function () {
  if (window.__ldd) return;
  window.__ldd = 1;
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var V = null, D = null, vakjes = [], bron = null, laatsteFocus = null, mode = 'pdp', regel = null, laden = null;
  var MAX = 6, VERPLICHT = 2;

  function geld(c) {
    var s = (c / 100).toFixed(2).replace('.', ',');
    return D && D.fmt === 'voor' ? '€' + s : s + ' €';
  }
  function q(s, el) { return (el || V).querySelector(s); }
  function opties(set, n) {
    var u = [];
    set.v.forEach(function (v) { var o = v[n]; if (o != null && u.indexOf(o) < 0) u.push(o); });
    return u;
  }
  function variant(set, o1, o2) {
    for (var i = 0; i < set.v.length; i++) { var v = set.v[i]; if (v[1] === o1 && (v[2] == null || v[2] === o2)) return v; }
    return null;
  }
  function variantId(set, id) {
    for (var i = 0; i < set.v.length; i++) { if (String(set.v[i][0]) === String(id)) return set.v[i]; }
    return null;
  }
  function tekst(k, r) {
    var s = D.t[k] || '';
    if (r) Object.keys(r).forEach(function (x) { s = s.replace('[' + x + ']', r[x]); });
    return s;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* TD98 (v91): de korting op een groep sets, per set zoals Shopify hem in de kassa rekent (gemeten 21 oktober):
     per set floor(prijs x percentage / 100), daarna opgeteld. 2895 geeft 289 korting, dus 2606 per set: 2 sets 5212, 6 sets 15636.
     Een vast bedrag per set (bedrag boven 0) gaat voor. */
  function korting(prijzen, p, bedrag) {
    if (!(p > 0)) return 0;
    var k = 0;
    prijzen.forEach(function (c) { k += bedrag > 0 ? bedrag : Math.floor(c * p / 100 + 1e-6); });
    return k;
  }
  /* v97 (TD-W1 punt 7, staffel B van Jasper, 25 oktober 2026): per set een eigen percentage. Set 1 volle prijs, set 2 pct[1] (10), set 3 pct[2] (15),
     tot set 6 pct[5] (30), elk per set naar beneden afgerond op de cent zoals de kassa. Alle sets in het venster kosten hetzelfde, dus de volgorde maakt niet uit.
     Zonder staffel (instelling Gelijk) krijgt elke set het percentage dat bij het aantal sets hoort, zoals tot v95. */
  /* v97 (staffel B, besluit S-5 van 25 oktober 2026): de kassa rekent met vaste bedragen per bestelling (Uitvoering U31: 2 sets 291, 3 sets 724 ... 10 sets 6369 cent),
     niet met de percentages per set (die geven 1 tot 2 cent verschil). Staan die bedragen in de instellingen (bedragen, index = aantal sets), dan rekent het thema daarmee;
     boven het hoogste aantal geldt het bedrag van het hoogste aantal, net als in Shopify. De percentages blijven de labels per vakje. */
  function kortingVan(prijzen, s) {
    if (!s || !s.pct) return 0;
    if (s.staffel && s.bedragen && s.bedragen.length > 2) {
      var n = prijzen.length;
      if (n < 2) return 0;
      return +s.bedragen[Math.min(n, s.bedragen.length - 1)] || 0;
    }
    if (s.staffel) {
      var k = 0;
      prijzen.forEach(function (c, i) { var p = s.pct[i] || 0; if (p > 0) k += Math.floor(c * p / 100 + 1e-6); });
      return k;
    }
    return korting(prijzen, s.pct[prijzen.length - 1] || 0, s.bedrag);
  }
  /* TD96b: de korting per aantal sets uit de sectie L'Adele bundel (footer, JSON blok #ldd-instellingen) */
  function lees() {
    var el = document.getElementById('ldd-instellingen');
    try { return el ? JSON.parse(el.textContent) : null; } catch (x) { return null; }
  }
  function instellingen(d) {
    var s = lees();
    if (!s) return false;
    var oud = JSON.stringify([d.pct, d.bedrag, d.bedragen || null]);
    var oudS = !!d.staffel;
    if (s.bedragen && s.bedragen.length > 2) d.bedragen = s.bedragen;
    if (s.pct && s.pct.length === 6) d.pct = s.pct;
    if (typeof s.bedrag === 'number') d.bedrag = s.bedrag;
    if (typeof s.staffel === 'boolean') d.staffel = s.staffel;
    return JSON.stringify([d.pct, d.bedrag, d.bedragen || null]) !== oud || oudS !== !!d.staffel;
  }
  /* de knop op de productpagina: 2 sets voor [b] met dezelfde rekenregel als het venster */
  function knoppen() {
    var s = lees();
    if (!s || !s.pct) return;
    Array.prototype.forEach.call(document.querySelectorAll('.ldd-knop[data-ldd-prijs]'), function (k) {
      var c = +k.getAttribute('data-ldd-prijs');
      var som = 2 * c - kortingVan([c, c], s);
      /* data-ldd-na: 0 euroteken voor het bedrag (nl), 1 erachter met spatie (de), 2 erachter met vaste spatie (fr, TD99) */
      var t = (som / 100).toFixed(2).replace('.', ',').replace(',00', ''), na = k.getAttribute('data-ldd-na');
      var lab = k.querySelector('[data-ldd-knoplabel]'), nieuw = k.getAttribute('data-ldd-sjabloon').replace('[b]', na === '1' ? t + ' €' : na === '2' ? t + String.fromCharCode(160) + '€' : '€' + t);
      if (lab && lab.textContent !== nieuw) lab.textContent = nieuw;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', knoppen); else knoppen();

  function laad() {
    if (V) return Promise.resolve(V);
    if (laden) return laden;
    /* bij een druk moment (429) of een lege sectie nog twee keer proberen, na 1,2 en 3 seconden */
    function haal(poging) {
      return fetch(R + '?section_id=ladele-duo-venster', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); })
        .then(function (h) { if (h.indexOf('data-ldd-venster') < 0) throw new Error('leeg'); return h; })
        .catch(function (e) {
          if (poging >= 2) throw e;
          return new Promise(function (ok) { setTimeout(ok, poging ? 3000 : 1200); }).then(function () { return haal(poging + 1); });
        });
    }
    laden = haal(0)
      .then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var el = doc.querySelector('[data-ldd-venster]');
        if (!el) throw new Error('geen venster');
        document.body.appendChild(el);
        V = document.body.querySelector('[data-ldd-venster]');
        D = JSON.parse(q('[data-ldd-data]').textContent);
        var anders = instellingen(D);
        /* TD97e (v90): filterknoppen alleen als de schakelaar in de sectie L'Adele bundel aan staat */
        var si = lees(), chips = q('[data-ldd-chips]');
        if (chips && si && si.filters === true) chips.hidden = false;
        var sub = q('.ldd__sub');
        if (anders && sub && D.staffel && D.t.subs) sub.textContent = D.t.subs.replace('[k2]', tekst('pct', { p: D.pct[1] }).replace('-', '')).replace('[k6]', tekst('pct', { p: D.pct[5] }).replace('-', ''));
        else if (anders && sub && D.t.sub) sub.textContent = D.t.sub.replace('[k]', D.bedrag > 0 ? geld(D.bedrag) : tekst('pct', { p: D.pct[1] }).replace('-', ''));
        /* v97 (TD-W1): bundelbeeld bovenin het venster als het in de sectie L'Adele bundel is gekozen */
        if (si && si.beeld && !q('.ldd__beeld')) {
          var bi = document.createElement('img');
          bi.className = 'ldd__beeld'; bi.src = si.beeld; bi.alt = ''; bi.width = 1500; bi.height = 600; bi.loading = 'lazy';
          var inh = q('.ldd__inhoud'); if (inh) inh.insertBefore(bi, inh.firstChild);
        }
        bind();
        return V;
      });
    laden.catch(function () { laden = null; });
    return laden;
  }

  function bind() {
    V.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-ldd-sluit]')) { sluit(); return; }
      var k = t.closest('[data-ldd-kies]');
      if (k) { kies(k.getAttribute('data-ldd-kies')); return; }
      var c = t.closest('[data-ldd-chip]');
      if (c) { filter(c); return; }
      var st = t.closest('[data-ldd-stap]');
      if (st) { stap(+st.getAttribute('data-ldd-stap')); return; }
      var w = t.closest('[data-ldd-weg]');
      if (w) { weg(+w.getAttribute('data-ldd-weg')); return; }
      if (t.closest('[data-ldd-toevoegen]')) { toevoegen(); return; }
    });
    V.addEventListener('change', function (e) {
      var s = e.target.closest('[data-ldd-optie]');
      if (!s) return;
      var i = +s.getAttribute('data-ldd-vak'), vk = vakjes[i];
      if (!vk) return;
      vk[s.getAttribute('data-ldd-optie')] = s.value;
      teken();
      var n = V.querySelector('[data-ldd-vak="' + i + '"][data-ldd-optie="' + s.getAttribute('data-ldd-optie') + '"]');
      if (n) n.focus();
    });
    V.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); sluit(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(V.querySelectorAll('button:not([disabled]),select,a[href],[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    });
  }

  function melding(s) { var m = q('[data-ldd-melding]'); m.textContent = ''; if (s) setTimeout(function () { m.textContent = s; }, 30); }

  function nieuwVak(handle, vid, vast) {
    var set = D.sets[handle];
    if (!set) return null;
    var v = vid ? variantId(set, vid) : null;
    if (!v) {
      var b = vakjes[0] && vakjes[0].o1 ? variant(set, vakjes[0].o1, vakjes[0].o2) : null;
      v = b && b[3] ? b : (set.v.filter(function (x) { return x[3]; })[0] || set.v[0]);
    }
    return { h: handle, o1: v[1], o2: v[2], vast: !!vast };
  }

  function leeg() { var v = []; for (var i = 0; i < MAX; i++) v.push(null); return v; }
  function aantal() { return vakjes.filter(function (x) { return x; }).length; }
  function kies(handle) {
    var i = vakjes.indexOf(null);
    if (i < 0) { melding(tekst('vol')); return; }
    vakjes[i] = nieuwVak(handle);
    teken();
    melding(tekst('gekozen', { naam: D.sets[handle].n }));
  }
  /* een vakje leegmaken: de sets erna schuiven op, zodat de gekozen sets altijd vooraan staan */
  function weg(i) {
    if (!vakjes[i] || vakjes[i].vast) return;
    vakjes.splice(i, 1);
    vakjes.push(null);
    teken();
    var b = V.querySelector('[data-ldd-vakjes] select, [data-ldd-vakjes] button') || V.querySelector('.ldd__kaart');
    if (b) b.focus();
  }
  /* tik op een vakje onderin: gevuld naar die set, leeg naar de lijst met sets */
  function stap(i) {
    var doel = vakjes[i] ? V.querySelector('[data-ldd-rij="' + i + '"] select, [data-ldd-rij="' + i + '"] .ldd__vaknaam') : V.querySelector('.ldd__item:not([hidden]) .ldd__kaart');
    if (!doel) return;
    doel.scrollIntoView({ block: 'center', behavior: 'smooth' });
    if (doel.focus) doel.focus({ preventScroll: true });
  }
  /* label van vakje i (0 tot 5): het percentage bij dat aantal sets; vakje 1 toont dat van 2 sets */
  function pct(i) {
    if (D.staffel) { var q2 = i >= 1 && D.pct ? D.pct[i] : 0; return q2 ? tekst('pct', { p: q2 }) : ''; }
    var p = D.pct && D.pct[Math.max(i, 1)]; return p ? tekst('pct', { p: p }) : '';
  }
  function filter(c) {
    var tag = c.getAttribute('data-ldd-chip');
    Array.prototype.forEach.call(V.querySelectorAll('[data-ldd-chip]'), function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
    Array.prototype.forEach.call(V.querySelectorAll('[data-ldd-tags]'), function (li) {
      li.hidden = !!tag && li.getAttribute('data-ldd-tags').indexOf('|' + tag + '|') < 0;
    });
  }

  function teken() {
    var ol = q('[data-ldd-vakjes]'), html = '', strook = '', oud = 0, n = 0, fout = false, prijzen = [];
    vakjes.forEach(function (vk, i) {
      var nr = tekst('set', { n: i + 1 }), lab = pct(i);
      if (!vk) {
        strook += '<li><button type="button" class="ldd__stap ldd__stap--leeg' + (i >= VERPLICHT ? ' ldd__stap--opt' : '') + '" data-ldd-stap="' + i + '" aria-label="' + esc(tekst('leeg', { n: i + 1 }) + (i >= VERPLICHT ? ' (' + tekst('opt') + ')' : '')) + '">' +
          '<span class="ldd__stapnr">' + (i >= VERPLICHT ? '+' : (i + 1)) + '</span>' + (lab ? '<span class="ldd__stappct">' + esc(lab) + '</span>' : '') + '</button></li>';
        return;
      }
      var set = D.sets[vk.h], v = variant(set, vk.o1, vk.o2), ok = v && v[3];
      if (ok || vk.vast) { oud += v ? v[4] : 0; n++; if (v) prijzen.push(v[4]); }
      if (!ok && !vk.vast) fout = true;
      strook += '<li><button type="button" class="ldd__stap" data-ldd-stap="' + i + '" aria-label="' + esc(nr + ': ' + set.n) + '"><img src="' + esc(set.img) + '" alt="" width="44" height="55" loading="lazy">' + (lab ? '<span class="ldd__stappct">' + esc(lab) + '</span>' : '') + '</button></li>';
      var s1 = opties(set, 1), s2 = opties(set, 2), sel = '';
      if (vk.vast) {
        sel = '<span class="ldd__vastregel">' + esc(vk.o1 + (vk.o2 ? ' · ' + vk.o2 : '')) + '</span><span class="ldd__al">' + esc(tekst('al')) + '</span>';
      } else {
        sel = '<span class="ldd__keuzes"><label><span>' + esc(tekst('shape')) + '</span><select data-ldd-vak="' + i + '" data-ldd-optie="o1">' +
          s1.map(function (o) { return '<option' + (o === vk.o1 ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('') + '</select></label>';
        if (s2.length) sel += '<label><span>' + esc(tekst('maat')) + '</span><select data-ldd-vak="' + i + '" data-ldd-optie="o2">' +
          s2.map(function (o) { return '<option' + (o === vk.o2 ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('') + '</select></label>';
        sel += '</span>' + (ok ? '' : '<span class="ldd__niet">' + esc(tekst('niet')) + '</span>');
      }
      html += '<li class="ldd__vak" data-ldd-rij="' + i + '"><img src="' + esc(set.img) + '" alt="" width="56" height="70" loading="lazy"><span class="ldd__vakinfo"><span class="ldd__vaknr">' + esc(nr) + '</span><span class="ldd__vaknaam" tabindex="-1">' + esc(set.n) + '</span>' + sel + '</span>' +
        (vk.vast ? '' : '<button type="button" class="ldd__weg" data-ldd-weg="' + i + '" aria-label="' + esc(tekst('weg') + ' ' + set.n) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg></button>') + '</li>';
    });
    ol.innerHTML = html;
    q('[data-ldd-strook]').innerHTML = strook;
    var knop = q('[data-ldd-toevoegen]'), klaar = n >= VERPLICHT && !fout;
    var nieuw = oud - kortingVan(prijzen, D), mist = VERPLICHT - n;
    knop.disabled = !klaar;
    q('[data-ldd-knoptekst]').textContent = klaar ? tekst('knop', { n: n }) : (mist > 1 ? tekst('nogn', { n: mist }) : tekst('nog'));
    q('[data-ldd-oud]').textContent = klaar && nieuw < oud ? geld(oud) : '';
    q('[data-ldd-nieuw]').textContent = klaar ? geld(nieuw) : '';
  }

  function duoId() { return 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6); }

  function post(url, body) {
    return fetch(R + url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }

  function toevoegen() {
    var knop = q('[data-ldd-toevoegen]');
    if (knop.disabled) return;
    knop.disabled = true;
    var id = duoId(), items = [];
    vakjes.forEach(function (vk) {
      if (!vk || vk.vast) return;
      var v = variant(D.sets[vk.h], vk.o1, vk.o2);
      if (v) items.push({ id: v[0], quantity: 1, properties: { _duo: id } });
    });
    var stap = Promise.resolve();
    if (mode === 'aanvul' && regel) {
      stap = post('cart/change.js', { id: regel.key, quantity: regel.qty, properties: { _duo: id } });
    }
    stap.then(function () { return post('cart/add.js', { items: items }); })
      .then(function (j) {
        sluit(true);
        var d = document.querySelector('m-cart-drawer'), pagina = document.querySelector('m-cart#MinimogCart');
        try { MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, Object.assign({}, j, { source: 'ladele-duo' })); } catch (x) {}
        if (!pagina && d) {
          if (d.onCartDrawerUpdate) d.onCartDrawerUpdate();
          if (d.open) d.open();
        }
      })
      .catch(function () { melding(tekst('fout')); knop.disabled = false; });
  }

  function open(btn) {
    bron = btn;
    laatsteFocus = document.activeElement;
    btn.setAttribute('aria-busy', 'true');
    laad().then(function () {
      btn.removeAttribute('aria-busy');
      var handle = btn.getAttribute('data-ldd-handle'), vid = btn.getAttribute('data-ldd-variant'), line = btn.getAttribute('data-ldd-line');
      mode = line ? 'aanvul' : 'pdp';
      regel = null;
      if (!vid && mode === 'pdp') {
        var f = document.querySelector('.m-product-form--main [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (f) vid = f.value;
      }
      vakjes = leeg();
      vakjes[0] = nieuwVak(handle, vid, mode === 'aanvul');
      if (mode === 'aanvul') {
        /* het vak tweede set staat er alleen bij precies 1 bundelset, dus aantal 1 */
        regel = { key: line, qty: 1 };
      }
      var chip = V.querySelector('[data-ldd-chip=""]');
      if (chip) filter(chip);
      melding('');
      teken();
      V.hidden = false;
      document.documentElement.classList.add('ldd-open');
      requestAnimationFrame(function () { V.classList.add('ldd--zichtbaar'); });
      var t = q('.ldd__sluit');
      if (t) t.focus();
      var lijst = q('.ldd__inhoud');
      if (lijst) lijst.scrollTop = 0;
    }).catch(function () {
      btn.removeAttribute('aria-busy');
      /* lukt het venster niet, dan naar alle sets; de korting rekent Shopify ook daar vanaf 2 sets */
      window.location.href = R + 'collections/alle-handgemaakte-soft-gel-nagels';
    });
  }

  function sluit(naToevoegen) {
    if (!V || V.hidden) return;
    V.classList.remove('ldd--zichtbaar');
    V.hidden = true;
    document.documentElement.classList.remove('ldd-open');
    if (!naToevoegen && laatsteFocus && laatsteFocus.focus) laatsteFocus.focus();
  }

  /* het venster alvast ophalen zodra de klant de knop aanraakt of er met het toetsenbord op komt */
  function vooraf(e) {
    var b = e.target.closest && e.target.closest('[data-ldd-open]');
    if (b && !V && !laden) laad().catch(function () {});
  }
  ['pointerover', 'touchstart', 'focusin'].forEach(function (t) { document.addEventListener(t, vooraf, { passive: true }); });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ldd-open]');
    if (!b) return;
    e.preventDefault();
    open(b);
  });
})();
